module.exports = __webpack_public_path__ + "img/q_highlight.7ad184d7.gif";